import * as React from 'react';
import Stack from '@mui/material/Stack';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';

import Search from './Search';
import ColorModeIconDropdown from '../shared-theme/ColorModeIconDropdown';
import { Box, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function Header() {
  return (
      <Stack
        direction="row"
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '100%',
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'space-between',
          maxWidth: { sm: '100%', md: '1700px' },
          pt: 1.5,
        }}
        spacing={2}
      >
        {/* <NavbarBreadcrumbs /> */}
        <Stack direction="row" display={'flex'} alignItems={'center'} sx={{ gap: 2 }}>
          <SearchIcon fontSize='medium'/>
          <MenuButton showBadge aria-label="Open notifications">
            <NotificationsRoundedIcon />
          </MenuButton>
        </Stack>
      </Stack>
  );
}